import { isDevTunnelHostname } from "@v1/backend/logic/dev_tunnel_origins";
import { isStaffHostname } from "@v1/backend/logic/organizations/staff_host";
import {
  PORTAL_APEX_DOMAIN,
  isPortalHostname,
  normalizeHostname,
} from "@v1/backend/logic/portal/portal_host";

/**
 * Prod hosts serve one product: staff app on hausverwalter.ai, portal on portalzugang.de.
 * Localhost, previews and tunnels serve both.
 */

const PORTAL_ONLY_PATH_PREFIXES = [
  "/portal",
  "/portal-sign-in",
  "/portal-accept",
  "/portal-launch",
  "/confirm-email",
] as const;

export function isPortalOnlyPath(pathname: string): boolean {
  return PORTAL_ONLY_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

/** Portal page requested on a staff host → same path on the portal apex. */
export function portalPathOnStaffHostRedirect(
  host: string,
  pathname: string,
  search: string,
): string | null {
  if (!isStaffHostname(host) || !isPortalOnlyPath(pathname)) return null;
  return `https://${PORTAL_APEX_DOMAIN}${pathname}${search}`;
}

/** Only unknown hosts can be a customer's own portal domain; saves the lookup elsewhere. */
export function needsPortalCustomHostLookup(host: string): boolean {
  const hostname = normalizeHostname(host);
  if (!hostname) return false;
  if (isStaffHostname(hostname) || isPortalHostname(hostname)) return false;
  if (hostname === "localhost" || hostname.endsWith(".localhost")) return false;
  if (hostname === "127.0.0.1") return false;
  return !hostname.endsWith(".vercel.app") && !isDevTunnelHostname(hostname);
}
